<template>
    <h3>
        {{ title }}
    </h3>
</template>

<script>
    export default {
        name: 'BrandBookHeading',

        props: {
            title: {
                type: String,
                required: true,
            },
        },

        inject: {
            page: {
                default() {
                    return null;
                },
            },
        },

        mounted() {
            if (this.page) this.page.registerHeading(this);
        },
    };
</script>
